export default function instructorsList() {
    return {
        selectedSubjectFilter: [],
        instructorsData: [],
        searchName: "",
        filterDataList: [],
        totalCount: 0,
        pageCount: 0,
        currentPage: 1,
        hasMore: false,
        showLoader: false,
        showErrorMesage: "",
        txtSearchInstructor: "",

        prev() {
            this.currentPage = this.currentPage - 1;
            this.bindInstructorsList();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.bindInstructorsList(false);
        },

        getDetailsUrl(item) {
            return (
                "/about/our-instructors/instructor-details?ref=" +
                item.id
            );
        },
        search() {
            this.currentPage = 1;
            this.instructorsData = [];
            this.bindInstructorsList();
        },

        viewDetails(id) {
          
            fetch("/api/ProgramAPI/SetSessionData?id="+id, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: id
                }),
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    window.location.href = response.redirectPath;
                });
        },
        bindInstructorsList() {
            var pageSize = 30;
            this.hasMore = false;
            this.showLoader = true;

            fetch("/api/ProgramAPI/GetInstructorList", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    PageSize: pageSize,
                    PageNumber: this.currentPage,
                    SelectedFilter: this.searchName === "" ? "" : this.searchName,
                }),
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(
                            this.instructorsData,
                            response.instructors
                        );

                        this.hasMore = response.hasMore;
                        this.showErrorMesage =
                            this.instructorsData.length <= 0 ? "No instructors found" : "";
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        init() {
            this.searchName = "";
            this.bindInstructorsList(false);
        },
    };
}
